const firebaseConfig = {
  apiKey: "AIzaSyA7Z8Q7x3KiaNwflPh0UloHPtyEYPDjzgo",
  authDomain: "noteit-down.firebaseapp.com",
  projectId: "noteit-down",
  storageBucket: "noteit-down.appspot.com",
  messagingSenderId: "620541104503",
  appId: "1:620541104503:web:494902f8dbb123d19d1172"
};
export default firebaseConfig;